module.exports = __webpack_public_path__ + "static/img/file-video.b6bcbf0e.svg";